import React from "react";
import Carousel from "react-grid-carousel";
import Dashboardcardlayout from "../../Components/Layout/Layout";
import Dashboardcard from "./dashboard-summary-card";
import "./dashboard-summary.css";
import PropTypes from 'prop-types';
import moment from "moment";
import useOrientationChange from "../../Utils/useOrientationChange";
import ResponsiveDashboardcardlayout from "../../Components/Layout/ResponsiveLayout";
const currentDate = moment().format("YYYY-MM-DD");

const DashboardSummary = (props) => {
  const calcWidth = window.innerWidth;
  const countRespondants = props.sentRespondants.map((items) => {
    return items.respondent_count;
  });
  const reducer = (accumulator, currentValue) => accumulator + currentValue;
  const fetchFilteredData = [];
  props.userAssessmentDetails.filter((filteredElements) => {
    if (currentDate > filteredElements.expiry_date) {
      return fetchFilteredData.push(filteredElements);
    }
  });



  useOrientationChange()

  return (
    <React.Fragment>
      {calcWidth <= 767 ?
        <ResponsiveDashboardcardlayout
          headerIcon={props.dashboardIcon}
          headerText="Dashboard Summary"
          marginStyle="dashboard-summary"
        >
          {calcWidth <= 767 ? (
            <Carousel
              gap={10}
              mobileBreakpoint={300}
              dotColorActive="black"
              showDots
            >
              <Carousel.Item>
                <div className="flex-wrapper">
                  <Dashboardcard
                    type="new_assessment"
                    count={props.newAssessmentCount}
                    pendingAssessment={props.pendingAssessmentCount}
                    expiredAssessment={fetchFilteredData.length}
                  />
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="flex-wrapper">
                  <Dashboardcard
                    type="completed"
                    count={props.completedAssessmentCount}
                  />
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="flex-wrapper">
                  <Dashboardcard
                    type="invitations"
                    count={props.myInvitationsCount}
                    invitations={countRespondants.reduce(reducer, 0)}
                  />
                </div>
              </Carousel.Item>
            </Carousel>
          ) : (
            <div className="flex-wrapper">
              <Dashboardcard
                type="new_assessment"
                count={props.newAssessmentCount}
                pendingAssessment={props.pendingAssessmentCount}
                expiredAssessment={fetchFilteredData.length}
              />
              <Dashboardcard
                type="completed"
                count={props.completedAssessmentCount}
              />
              <Dashboardcard
                type="invitations"
                count={props.myInvitationsCount}
                invitations={countRespondants.reduce(reducer, 0)}
              />
            </div>
          )}
        </ResponsiveDashboardcardlayout>
        :
        <Dashboardcardlayout
          headerIcon={props.dashboardIcon}
          headerText="Dashboard Summary"
        >
          {calcWidth <= 767 ? (
            <Carousel
              gap={0}
              mobileBreakpoint={300}
              dotColorActive="black"
              showDots
            >
              <Carousel.Item>
                <div className="flex-wrapper">
                  <Dashboardcard
                    type="new_assessment"
                    count={props.newAssessmentCount}
                    pendingAssessment={props.pendingAssessmentCount}
                    expiredAssessment={fetchFilteredData.length}
                  />
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="flex-wrapper">
                  <Dashboardcard
                    type="completed"
                    count={props.completedAssessmentCount}
                  />
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="flex-wrapper">
                  <Dashboardcard
                    type="invitations"
                    count={props.myInvitationsCount}
                    invitations={props.myInvitationsCount}
                  />
                </div>
              </Carousel.Item>
            </Carousel>
          ) : (
            <div className="flex-wrapper">
              <Dashboardcard
                type="new_assessment"
                count={props.newAssessmentCount}
                pendingAssessment={props.pendingAssessmentCount}
                expiredAssessment={fetchFilteredData.length}
              />
              <Dashboardcard
                type="completed"
                count={props.completedAssessmentCount}
              />
              <Dashboardcard
                type="invitations"
                count={props.myInvitationsCount}
                invitations={countRespondants.reduce(reducer, 0)}
              />
            </div>
          )}

        </Dashboardcardlayout>}
    </React.Fragment>
  );
};


DashboardSummary.propTypes = {
  sentRespondants: PropTypes.arrayOf(PropTypes.shape({
    respondent_count: PropTypes.number.isRequired
  })).isRequired,
  userAssessmentDetails: PropTypes.arrayOf(PropTypes.shape({
    expiry_date: PropTypes.string.isRequired
  })).isRequired,
  dashboardIcon: PropTypes.string.isRequired,
  newAssessmentCount: PropTypes.number.isRequired,
  pendingAssessmentCount: PropTypes.number.isRequired,
  completedAssessmentCount: PropTypes.number.isRequired,
  myInvitationsCount: PropTypes.number.isRequired
};

export default DashboardSummary;



// WEBPACK FOOTER //
// ./src/new/Dashboard/Dashboard-summary/dashboard-summary.jsx